<script lang="typescript">
    import { beforeUpdate, onMount } from "svelte";

    export let isValid = true;

    export let virtualValidations: IValidationResult[] = [];

    let iVAlidations = virtualValidations;
    $: {
        iVAlidations = virtualValidations;
        calculateValidation();
    }

    let fieldValidations: { [name: string]: IValidationResult } = {};

    const onValidation = (e: CustomEvent) => {
        let { name, validation } = e.detail;
        fieldValidations[name] = validation;
        calculateValidation();
    };

    const calculateValidation = () => {
        let valid = true;

        for (const key of Object.keys(fieldValidations)) {
            let validation = fieldValidations[key];
            if (!validation.isValid) {
                valid = false;
                break;
            }
        }

        for (const vValidation of virtualValidations) {
            if (!vValidation.isValid) {
                valid = false;
                break;
            }
        }

        isValid = valid;
    };

    let form: HTMLFormElement;

    onMount(() => {
        form && form.addEventListener("form-validation", onValidation as any);
    });
</script>

<form bind:this={form} on:submit|preventDefault={() => {}} class="form">
    <slot />
</form>

<style>
    .form {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
</style>
